/**
 * contentupdatesreducer.js
 * Created by calhosh on 12/16/2020.
 */

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function contentUpdatesReducer(state = initialState.contentUpdates, action) {
	switch (action.type) {
		case types.GET_CONTENT_UPDATES: {
			if (action.response || action.response.formData) {
				return action.response;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}
